<div class="content-wrapper" style="min-height: 368px">
  <div class="pt-2 pb-2">
    <div class="card m-2">
      <div class="card-body" style="padding: 5px;">
        <h1 style="text-decoration: underline;" class="card-title text-center">
          Casino games
          <small *ngIf="is_active;" class="balance d-none">Balance: {{balance}}p</small>
        </h1>
        <div *ngIf="is_active; else notActive" id="game_container">
        <button *ngFor="let vendor of vendors" (click)="getGameList(vendor)" class="btn btn-warning btn-sm ml-1" [class.active]="activeVendor==vendor">{{ vendor }}</button>

        <div *ngIf="gameurl==''; else gameWindow">
          <h4 class="mt-4">{{activeVendor}}</h4>
          <div *ngIf="isloading; else gamelist">
            <mat-spinner diameter="40"></mat-spinner> <!-- Add a loading spinner here -->
          </div>
          <ng-template #gamelist>
          <div *ngIf="gameList.length>0; else nogame" class="row col-12 w-100 p-0 m-0 mb-2">
            <div *ngFor="let game of gameList" class="col-lg-2 col-md-3 col-6 p-0">
              <img class="game_banner" (click)="openNewGameTab(game.uuid)" src="{{game.image}}" />
              <!-- <img class="game_banner" (click)="getGameUrl(game.uuid)" src="{{game.image}}" /> -->
            </div>
          </div>
          <ng-template #nogame>
            <div class="col-12 p-0">
              <h4>No games found...</h4>
            </div>
          </ng-template>
          </ng-template>
        </div>
        <ng-template #gameWindow>
          <div class="col-md-12 mt-4 p-0">
            <iframe [src]="gameurl" width="100%" height="600px" title="game"></iframe>
          </div>
        </ng-template>
        </div>
        <ng-template #notActive>
        <div class="pt-4 text-center" id="contact_us">
          <h3 class="contact_notice">Notice: Your casino account is not active, click to active.</h3>
          <br>
          <button type="button" [disabled]="clicked" (click)="activateAccount(); clicked = true;" class="btn btn-primary btn-lg mt-3 text-dark">Activate account</button>
        </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
